module.exports = __webpack_public_path__ + "static/media/banner_marketing.171ce4de.png";